import { Box } from '@material-ui/core';

import { SCheckbox, SText } from '@setvi/shared/components';

import { ORDER_NOTES } from '../../constants';
import { useStyles } from './styles';

interface OrderNotesProps {
  accepted: boolean;
  onToggle: (accepted: boolean) => void;
}

export const OrderNotes = ({ accepted, onToggle }: OrderNotesProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.notesBox}>
      <SText
        title="Please review the notes below and accept before placing your order:"
        weight="semibold"
        maxLines="unset"
        noLineClamp
      />
      <ul className={classes.notesList}>
        {ORDER_NOTES.map(note => (
          <li key={note}>
            <SText
              title={note}
              size="sm"
              fontColor="#5D7083"
              maxLines="unset"
              noLineClamp
            />
          </li>
        ))}
      </ul>

      <Box className={classes.acceptRow} onClick={() => onToggle(!accepted)}>
        <SCheckbox
          checked={accepted}
          onChange={(_, checked) => onToggle(checked)}
          onClick={e => e.stopPropagation()}
        />
        <SText
          title="I accept the notes above."
          weight="semibold"
          maxLines="unset"
        />
      </Box>
    </Box>
  );
};
